var React = require('react');

function Remove (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"0.999996","y":"8.7","width":"22","height":"6.6","rx":"0.5","fill":"currentColor"}));
}

Remove.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Remove;

Remove.default = Remove;
